import { PresetVisibility } from '@aibees/shared/definition';

export const tabs = [
  { label: 'All', value: PresetVisibility.ALL },
  { label: 'Mine', value: PresetVisibility.PRIVATE },
  { label: 'Shared', value: PresetVisibility.INTERNAL },
];

export const tabPanels = [
  { value: PresetVisibility.ALL, component: <>{PresetVisibility.ALL}</> },
  {
    value: PresetVisibility.PRIVATE,
    component: <>{PresetVisibility.PRIVATE}</>,
  },
  {
    value: PresetVisibility.INTERNAL,
    component: <>{PresetVisibility.INTERNAL}</>,
  },
];
